
<i18n>
  {
    "fr": {
      "change-email-title": "Modification de l'adresse courriel",
      "change-email-message1": "Attention! Cette opération modifiera l'adresse courriel que vous utilisez pour vous connecter à toutes les entreprises auxquelles votre compte est associé.",
      "change-email-message2": "Assurez-vous que la nouvelle adresse est activée et accessible. Un courriel de vérification sera envoyé à la nouvelle adresse fournie. Il contiendra un lien qui vous permettra de passer au travers des étapes requises pour confirmer le changement demandé.",
      "change-email-message-admin1": "Attention! Cette opération modifiera l'adresse courriel utilisée pour se connecter à toutes les entreprises auxquelles le compte de l'utilisateur est associé.",
      "change-email-message-admin2": "Afin d'éviter le piratage psychologique, assurez-vous de valider l'identité de la personne effectuant la demande par un moyen sûr.",
      "change-email-new-email":"Nouvelle adresse courriel",
      "change-email-new-email-confirm":"Confirmer l'adresse courriel",
      "change-email-cancel": "Annuler",
      "change-email-confirm": "Envoyer le courriel de vérification",
      "change-email-confirm-admin": "Modifier le courriel",

      "error-email-empty": "L'adresse courriel est obligatoire",
      "error-email-invalid": "L'adresse courriel est invalide",
      "error-email-confirm": "L'adresse de confirmation doit être identique"
    },
    "en": {
      "change-email-title": "Change email address",
      "change-email-message1": "Warning! This will change the email address you use to sign in to any businesses your account is associated with.",
      "change-email-message2": "Make sure the new address is enabled and accessible. A verification email will be sent to the new address provided. It will contain a link that will take you through the steps required to confirm the requested change.",
      "change-email-message-admin1": "Warning! This will change the email address used to log in to all companies the user's account is associated with.",
      "change-email-message-admin2": "To avoid social hacking, be sure to validate the identity of the person making requesting the change through secure means.",
      "change-email-new-email":"New email address",
      "change-email-new-email-confirm":"Confirm new email address",
      "change-email-cancel": "Cancel",
      "change-email-confirm": "Send verification email",
      "change-email-confirm-admin": "Change the email",

      "error-email-empty": "The email address is required",
      "error-email-invalid": "The email address is invalid",
      "error-email-confirm": "The confirm address must be the identical"
    }
  }
  </i18n>
  <template>
  <b-modal v-model="showModal" has-modal-card>
    <template #default="{ close }">
      <s-form ref="form" @submit="onSubmit">
        <div class="modal-card">
          <header class="modal-card-head">
            <h2 class="modal-card-title">{{ $t('change-email-title') }}</h2>
            <button type="button" class="delete" @click="close"></button>
          </header>

          <section class="modal-card-body" v-if="!!formModel">
            <b-notification type="content is-warning is-light is-small" :closable="false">
              <template v-if="adminMode">
                <p>{{ $t('change-email-message-admin1') }}</p>
                <p>{{ $t('change-email-message-admin2') }}</p>
              </template>
              <template v-else>
                <p>{{ $t('change-email-message1') }}</p>
                <p>{{ $t('change-email-message2') }}</p>
              </template>
            </b-notification>

            <s-field :label="$t('change-email-new-email')" :value="formModel.email" :rules="rules.email" validate-on-input>
              <b-input v-model="formModel.email" />
            </s-field>

            <s-field
              :label="$t('change-email-new-email-confirm')"
              :value="formModel.confirmEmail"
              :rules="rules.confirmEmail"
              validate-on-input
            >
              <b-input v-model="formModel.confirmEmail" />
            </s-field>
          </section>

          <footer class="modal-card-foot is-justify-content-end">
            <b-button @click="close">
              {{ $t('change-email-cancel') }}
            </b-button>
            <b-button native-type="submit" type="is-warning" :loading="loading">
              {{ adminMode ? $t('change-email-confirm-admin') : $t('change-email-confirm') }}
            </b-button>
          </footer>
        </div>
      </s-form>
    </template>
  </b-modal>
</template>

<script>
import SForm from '@/components/form/form'

import SField from '@/components/form/field'
import FormHelper from '@/helpers/form'

export default {
  components: { SForm, SField },
  props: {
    loading: Boolean,
    adminMode: Boolean
  },
  data() {
    return {
      showModal: false,
      formModel: null
    }
  },
  computed: {
    rules() {
      return {
        email: [
          (value) => FormHelper.notEmpty(value) || this.$t('error-email-empty'),
          (value) => FormHelper.isEmail(value) || this.$t('error-email-invalid')
        ],
        confirmEmail: [
          (value) => FormHelper.notEmpty(value) || this.$t('error-email-empty'),
          (value) => FormHelper.isEmail(value) || this.$t('error-email-invalid'),
          (value) => FormHelper.isSame(this.formModel.email, value) || this.$t('error-email-confirm')
        ]
      }
    }
  },
  methods: {
    open() {
      this.resetModel()
      this.showModal = true
    },
    close() {
      this.resetModel()
      this.showModal = false
    },
    resetModel() {
      this.formModel = {
        email: '',
        confirmEmail: ''
      }
    },
    onSubmit() {
      if (!this.$refs.form.validate()) return

      this.$emit('change-email', this.formModel.email)
    }
  }
}
</script>

<style>
</style>